import { render, staticRenderFns } from "./ServiceCompositionList.vue?vue&type=template&id=73b08410&scoped=true"
import script from "./ServiceCompositionList.vue?vue&type=script&lang=js"
export * from "./ServiceCompositionList.vue?vue&type=script&lang=js"
import style0 from "./ServiceCompositionList.vue?vue&type=style&index=0&id=73b08410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b08410",
  null
  
)

export default component.exports